import React from 'react';
import { useState,useEffect } from 'react';
import NavCard from '../NavCard';
import '../../styles/NavCard.css'

const Navoptionstv = ({tv}) => {
    console.log("miphones",tv);
    
    return (
        <>         
         <div className="navOptions">
         {  tv.map((item,index)=>{  
             console.log("111111111",item)
             return(
          <NavCard name={item['name']} price={item['price']} image={item['image']} key={item['image']} index={index}></NavCard> 
             )
              })
         }

         </div>  

        </>
    )
}

export default Navoptionstv;
